module.exports = __webpack_public_path__ + "img/solution-farmer-advantage4.904b8f18.svg";